import React from 'react';

/** Barre de progression tokenisée. */
export default function WorkflowProgressBar({ pct = 0, color, compact }) {
  const v = Math.max(0, Math.min(100, Math.round(pct)));
  return (
    <div className={`wf-progress ${compact ? 'wf-progress-compact' : ''}`}>
      <div className="wf-progress-track">
        <div className="wf-progress-fill" style={{ width: `${v}%`, background: color || 'var(--color-accent)' }} />
      </div>
      <span className="wf-progress-label">{v}%</span>
    </div>
  );
}
